import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper
} from '@mui/material';
import { SupervisorCustomerReportItem, formatCurrency, formatProfitRate } from '../../../../types/sales';

interface SupervisorCustomerTableProps {
  data: SupervisorCustomerReportItem[];
  selectedSupervisor?: string; // 追加: 選択された担当者名
}

export const SupervisorCustomerTable: React.FC<SupervisorCustomerTableProps> = ({ 
  data,
  selectedSupervisor = "" // デフォルト値を空文字に設定
}) => {
  if (data.length === 0) return null;

  // 詳細データ（合計行を除く）を取得
  const detailData = data.length > 1 ? data.slice(0, data.length - 1) : data;
  
  // 選択された担当者でフィルタリング
  const filteredData = selectedSupervisor 
    ? detailData.filter(item => item.supervisor_name === selectedSupervisor)
    : detailData;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>担当者名</TableCell>
            <TableCell>顧客名</TableCell>
            <TableCell align="right">工事件数</TableCell>
            <TableCell align="right">売上合計</TableCell>
            <TableCell align="right">粗利益</TableCell>
            <TableCell align="right">粗利益率</TableCell>
            <TableCell align="right">職長手当</TableCell>
            <TableCell align="right">最終利益</TableCell>
            <TableCell align="right">最終利益率</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((item: SupervisorCustomerReportItem, index) => (
            <TableRow key={`${item.supervisor_name}-${item.customer_name}-${index}`}>
              <TableCell>{item.supervisor_name}</TableCell>
              <TableCell>{item.customer_name}</TableCell>
              <TableCell align="right">{item.project_count}</TableCell>
              <TableCell align="right">{formatCurrency(item.total_sales)}</TableCell>
              <TableCell
                align="right"
                sx={{ color: item.final_profit < 0 ? 'error.main' : 'success.main' }}
              >
                {formatCurrency(item.final_profit)}
              </TableCell>
              <TableCell align="right">{formatProfitRate(item.final_profit)}</TableCell>
              <TableCell align="right">{formatCurrency(item.supervisor_allowance)}</TableCell>
              <TableCell
                align="right"
                sx={{ color: item.final_profit < 0 ? 'error.main' : 'success.main' }}
              >
                {formatCurrency(item.final_profit)}
              </TableCell>
              <TableCell align="right">{formatProfitRate(item.final_profit_rate)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};